import { render, staticRenderFns } from "./regionalAdministratorList.vue?vue&type=template&id=4a3696d4&scoped=true&"
import script from "./regionalAdministratorList.vue?vue&type=script&lang=js&"
export * from "./regionalAdministratorList.vue?vue&type=script&lang=js&"
import style0 from "./regionalAdministratorList.vue?vue&type=style&index=0&id=4a3696d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3696d4",
  null
  
)

export default component.exports